export const filterCriteria = [
    {
        label: "Traceability System",
        code: "traceabilitySystem",
        numCharsToSearch: 1,
        field: { type: "input", label: "traceability system" },
        isPartial: true,
    },
    {
        label: "State",
        code: "state",
        numCharsToSearch: 1,
        field: { type: "input", label: "state" },
        isPartial: true,
    },
    {
        label: "Inventory Type Code",
        code: "inventoryTypeCode",
        numCharsToSearch: 1,
        field: { type: "input", label: "inventory type code" },
        isPartial: true,
    },
    {
        label: "Inventory Type",
        code: "inventoryType",
        numCharsToSearch: 3,
        field: { type: "input", label: "inventory type" },
        isPartial: true,
    },
    { label: "Id", code: "_id", field: { type: "input", label: "Id" } },
  ];

  export const searchColumnHeaders = [
    {
        id: "select",
        type: "button",
        action: "selectItem",
        position: "sticky",
        iconName: "hand-pointer",
        ariaLabel: "Open",
    },
    {
        title: "Traceability System",
        id: "traceabilitySystem",
    },
    {
        title: "State",
        id: "state",
    },
    {
        title: "Inventory Type Code",
        id: "inventoryTypeCode",
    },
    {
        title: "Inventory Type",
        id: "inventoryType",
    },
    {
        title: "Archived",
        id: "isArchived",
    },
    {
        title: "Deleted",
        id: "isDeleted",
    },
    {
        title: "Id",
        id: "_id",
    },
  ];

  export const defaultDfInventoryType = {
    _id: "NEW",
    traceabilitySystem: "",
    state: "",
    inventoryTypeCode: "",
    inventoryType: "",
    isArchived: false,
    isDeleted: false,
  };